/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _styled = _interopRequireDefault(require("../styles/styled"));
var _useTheme = _interopRequireDefault(require("../styles/useTheme"));
var _hiddenCssClasses = require("./hiddenCssClasses");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes, breakpoints } = ownerState;
    const slots = {
        root: [
            'root',
            ...breakpoints.map((param)=>{
                let { breakpoint, dir } = param;
                return dir === 'only' ? "".concat(dir).concat((0, _capitalize.default)(breakpoint)) : "".concat(breakpoint).concat((0, _capitalize.default)(dir));
            })
        ]
    };
    return (0, _composeClasses.default)(slots, _hiddenCssClasses.getHiddenCssUtilityClass, classes);
};
// FIXME(romgrk): Can't use memoTheme here, should we memo also on ownerState?
const HiddenCssRoot = (0, _styled.default)('div', {
    name: 'PrivateHiddenCss',
    slot: 'Root'
})((param)=>{
    let { theme, ownerState } = param;
    const hidden = {
        display: 'none'
    };
    return {
        ...ownerState.breakpoints.map((param)=>{
            let { breakpoint, dir } = param;
            if (dir === 'only') {
                return {
                    [theme.breakpoints.only(breakpoint)]: hidden
                };
            }
            return dir === 'up' ? {
                [theme.breakpoints.up(breakpoint)]: hidden
            } : {
                [theme.breakpoints.down(breakpoint)]: hidden
            };
        }).reduce((r, o)=>{
            Object.keys(o).forEach((k)=>{
                r[k] = o[k];
            });
            return r;
        }, {})
    };
});
/**
 * @ignore - internal component.
 */ function HiddenCss(props) {
    const { children, className, only, ...other } = props;
    const theme = (0, _useTheme.default)();
    if ("production" !== 'production') {
        const unknownProps = Object.keys(other).filter((propName)=>{
            const isUndeclaredBreakpoint = !theme.breakpoints.keys.some((breakpoint)=>{
                return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
            });
            return ![
                'classes',
                'theme',
                'isRtl',
                'sx'
            ].includes(propName) && isUndeclaredBreakpoint;
        });
        if (unknownProps.length > 0) {
            console.error('MUI: Unsupported props received by `<Hidden implementation="css" />`: '.concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
        }
    }
    const breakpoints = [];
    for(let i = 0; i < theme.breakpoints.keys.length; i += 1){
        const breakpoint = theme.breakpoints.keys[i];
        const breakpointUp = other["".concat(breakpoint, "Up")];
        const breakpointDown = other["".concat(breakpoint, "Down")];
        if (breakpointUp) {
            breakpoints.push({
                breakpoint,
                dir: 'up'
            });
        }
        if (breakpointDown) {
            breakpoints.push({
                breakpoint,
                dir: 'down'
            });
        }
    }
    if (only) {
        const onlyBreakpoints = Array.isArray(only) ? only : [
            only
        ];
        onlyBreakpoints.forEach((breakpoint)=>{
            breakpoints.push({
                breakpoint,
                dir: 'only'
            });
        });
    }
    const ownerState = {
        ...props,
        breakpoints
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenCssRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        children: children
    });
}
"production" !== "production" ? HiddenCss.propTypes = {
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */ implementation: _propTypes.default.oneOf([
        'js',
        'css'
    ]),
    /**
   * If `true`, screens this size and down are hidden.
   */ lgDown: _propTypes.default.bool,
    /**
   * If `true`, screens this size and up are hidden.
   */ lgUp: _propTypes.default.bool,
    /**
   * If `true`, screens this size and down are hidden.
   */ mdDown: _propTypes.default.bool,
    /**
   * If `true`, screens this size and up are hidden.
   */ mdUp: _propTypes.default.bool,
    /**
   * Hide the given breakpoint(s).
   */ only: _propTypes.default.oneOfType([
        _propTypes.default.oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl'
        ]),
        _propTypes.default.arrayOf(_propTypes.default.oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl'
        ]))
    ]),
    /**
   * If `true`, screens this size and down are hidden.
   */ smDown: _propTypes.default.bool,
    /**
   * If `true`, screens this size and up are hidden.
   */ smUp: _propTypes.default.bool,
    /**
   * If `true`, screens this size and down are hidden.
   */ xlDown: _propTypes.default.bool,
    /**
   * If `true`, screens this size and up are hidden.
   */ xlUp: _propTypes.default.bool,
    /**
   * If `true`, screens this size and down are hidden.
   */ xsDown: _propTypes.default.bool,
    /**
   * If `true`, screens this size and up are hidden.
   */ xsUp: _propTypes.default.bool
} : void 0;
var _default = exports.default = HiddenCss;
